<template>
  <div class="card-form">
    <div style="margin-top:10px;">
      <page-header
        slot="header"
        ref="header"
        @reset="reset"
        @submit="handleSubmit"
      ></page-header>
    </div>
    <page-main :table-data="table" :isShow="isShow"></page-main>
    <js-pagination
      :current-page="page.curPage"
      :page-size="page.pageSize"
      :page-total="page.pageTotal"
      :pageSizes="pageSizes"
      align="right"
      @change="handlePaginationChange"
      v-if="isShow"
    />
  </div>
</template>
<script>
// import { listApi } from '@api/resourceManagement/researchInfo'
export default {
  name: 'researchInfo',
  computed: {},
  components: {
    PageHeader: () => import('./components/header'),
    PageMain: () => import('./components/main')
  },
  // 数据
  data() {
    return {
      table: [],
      isShow: true,
      page: {
        curPage: 1,
        pageSize: 8,
        pageTotal: 0
      },
      pageSizes: [8, 20, 40, 80, 100]
    }
  },
  // 侦听器
  watch: {},
  // 生命周期钩子
  mounted() {},
  // 事件处理方法
  methods: {
    // 分页变化改动
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total
      }
      this.$nextTick(() => {
        this.$refs.header.query()
      })
    },
    handleSubmit(form) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$api
        .researchInfoListApi({
          ...form,
          ...this.page
        })
        .then((res) => {
          loading.close()
          this.page.pageTotal = res.body.count
          this.table = res.body.data
          if (this.table.length > 0) {
            this.isShow = true
          } else {
            this.isShow = false
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    reset() {
      this.page = {
        curPage: 1,
        pageSize: 8,
        pageTotal: 0
      }
    }
  }
}
</script>

<style lang="scss"></style>
